import api from "./client";
export async function listBanners() {
    const res = await api.get("/admin/banners");
    return res.data;
}
export async function getBanner(id) {
    const res = await api.get(`/admin/banners/${id}`);
    return res.data;
}
export async function upsertBanner(data) {
    const res = await api.post("/admin/banners", data);
    return res.data;
}
export async function deleteBanner(id) {
    await api.delete(`/admin/banners/${id}`);
}
